export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 110,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('shipment_customer_shipmentType') || '收发货人类型',
    field: 'v_shipmentType',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_numberType') || '发运客户代码类型',
    field: 'numberType',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_shipmentCustomerNo') || '发运客户代码',
    field: 'shipmentCustomerNo',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_shipmentCustomerName') || '发运客户名称',
    field: 'shipmentCustomerName',
    minWidth: 280,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_shipmentCustomerEnName') || '发运客户英文名称',
    field: 'shipmentCustomerEnName',
    minWidth: 280,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_shipmentCustomerAddress') || '发运客户地址',
    field: 'shipmentCustomerAddress',
    width: 350,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_shipmentCustomerPhoneNo') || '发运客户电话',
    field: 'shipmentCustomerPhoneNo',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_regionNo') || '国家代码',
    field: 'regionNo',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_aeoNo') || 'AEO企业编码',
    field: 'aeoNo',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_contacts') || '联系人',
    field: 'contacts',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_contactsPhoneNo') || '联系电话',
    field: 'contactsPhoneNo',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_contactsEmail') || '联系邮件地址',
    field: 'contactsEmail',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_contactsFax') || '联系传真',
    field: 'contactsFax',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_custCode') || '所属客户',
    field: 'custName',
    width: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_bankCode') || '开户银行代码',
    field: 'bankCode',
    width: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_bankName') || '开户银行名称',
    field: 'bankName',
    width: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'bankEnName',
    headerAlign: 'center',
    align: 'left',
    width: 220,
    title: that.$l('shipment_customer_bankEnName') || '开户银行英文名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_bankAddress') || '开户银行中文地址',
    field: 'bankAddress',
    width: 280,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_bankEnAddress') || '开户银行英文地址',
    field: 'bankEnAddress',
    width: 280,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_bankAccountName') || '开户银行账号名称',
    field: 'bankAccountName',
    width: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('shipment_customer_bankAccountNo') || '开户银行账号',
    field: 'bankAccountNo',
    width: 220,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createDate',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
